// s60-list-notifications.js
import selfHtml from './s60-list_notifications.html' with { type: 'text' };;

import { db_Notifications, db_ExtPub } from "../AppState.js";
import { navbar_active_menu, showOffcanvas } from "../utils.js";

var listgroup_notifications
var listgroup_item_master
var listDetails
var listPanel
var default_detail_content
var detailContent
var detailContent_original
var root
var init_message_id
var iframe

const SCREEN_SIZE__MD = 768

export async function init(module_root, args) {

    init_message_id = args?.key

    module_root.innerHTML = selfHtml;

    root = module_root

    // await mod_loader(NotificationModule, { target: ".main_offcanva_section_notify" });

    listgroup_notifications = root.querySelector(".list-group");
    listgroup_item_master = root.querySelector(".list-group-item").cloneNode(true);
    detailContent = root.querySelector('.detailContent');
    default_detail_content = root.querySelector('.default_detail_content');
    detailContent_original = detailContent.innerHTML;
    iframe = detailContent.querySelector(".mapIframe");

    listDetails = root.querySelector(".listDetails");
    listPanel = root.querySelector(".listPanel");

    navbar_active_menu(".list_notifications")

    root.querySelector(".btn_request_auth_notification").addEventListener('click', () => { showOffcanvas('offcanvasNotificationPanel') });
    root.querySelector(".btn_clear_all_notification").addEventListener('click', clear_all_notification);

    default_detail_content.style.display = 'block'; // show
    detailContent.style.display = 'none';

    display_notifications();

}
// -------------------------------------------------------------------------------------------
async function display_notifications() {

    const notifications = await db_Notifications.keys();

    if (notifications.length)
        listgroup_notifications.innerHTML = ''
    else
        listgroup_notifications.innerHTML = "No items"

    // To sort the main array by username it is needed to build array key/names 
    var dates = [];

    for (const key of notifications) {
        const notifications = await db_Notifications.get(key);
        dates[key] = notifications.data.client_data?.share_time;
    }

    notifications.sort((a, b) =>
        dates[a].localeCompare(dates[b])
    ).reverse();

    for (const key of notifications) {
        const notification = await db_Notifications.get(key);
        await add_item(key, notification);
        notification.was_displayed = true;
        db_Notifications.set(key, notification); // console.log("UNCOMMENT THIS to make notifications read"); 
    }

}
// -------------------------------------------------------------------------------------------
async function add_item(key, notification) {

    root.querySelector(".btn_clear_all_notification").disabled = false;
    
    if (init_message_id == key)
        notification_details(notification)

    const item = listgroup_item_master.cloneNode(true);
    let rcpt = notification?.data?.pgp_pub_rcpt;

    if (rcpt != null && rcpt[0]) {
        // TODO: display multiple rcpt, not only the first
        const result = await db_ExtPub.get(rcpt[0]);
        if (result)
            rcpt = result.userID[0]
    }

    if (rcpt == null)
        rcpt = "Anyone with the link"

    item.querySelector(".notif_hkey").innerText = notification?.data?.hkey;
    item.querySelector(".notif_rcpt").innerText = rcpt;
    item.querySelector(".timestamp_access").innerText = new Date(notification?.data?.client_data?.share_time).toLocaleString();

    if (notification.data.notify_msg_downloaded_by_rcpt == true) {
        item.querySelector(".notif_title").innerText = "Message delivered";
    } else if (notification.data.notify_suspect == true) {
        item.querySelector(".notif_title").innerText = "Suspect download";
        item.querySelector(".notif_suspect_download_icon").classList.remove("collapse");
    } else if (notification.data.notify_test_success == true) {
        item.querySelector(".notif_title").innerText = "Test notification";
    } else {
        item.querySelector(".notif_title").innerText = "Unknown notification error";
    }

    if (notification.was_displayed == true)
        item.querySelector(".item_new_circle").style.display = 'none';

    item.addEventListener('click', (event) => {

        iframe.src = "";
        if (event) event.preventDefault(); // Not sure if this is needed at all.

        if (event.target.closest(".btn_delete_this_item")) {
            const target_item = event.target.closest(".list-group-item");
            if (target_item.classList.contains("active")) {
                detailContent.innerHTML = detailContent_original
                target_item.classList.remove("active");
            }

            if (target_item.parentElement.childElementCount > 1)
                target_item.remove()
            else
                target_item.parentElement.innerHTML = "Empty list"

            return;

        }

        default_detail_content.style.display = 'none';
        detailContent.style.display = 'block'; // show

        // Clear all highlight list-item 
        const listArray = Array.from(event.target.closest(".list-group").children)
        listArray.forEach(child_item => child_item.classList.remove("active"));

        // highlight one list-item 
        event.target.closest(".list-group-item").classList.add("active");

        notification_details(notification);

        if (window.innerWidth < SCREEN_SIZE__MD) {
            listPanel.classList.add('d-none');
            listDetails.classList.remove('d-none');
        }

        listDetails.querySelector(".btn_back_to_list").addEventListener('click', () => {
            if (window.innerWidth < SCREEN_SIZE__MD) {
                listPanel.classList.remove('d-none');
                listDetails.classList.add('d-none');
            }
        })

    });

    item.querySelectorAll("div").forEach(div => { div.classList.add("text-body-secondary") })

    listgroup_notifications.appendChild(item)

}
// -------
function notification_details(notification) {

    const client_data = notification?.data?.client_data;
    detailContent.querySelector(".message_id").value = client_data?.hkey;
    detailContent.querySelector(".message_creation_date").value = client_data?.creation_time;
    detailContent.querySelector(".message_share_date").value = client_data?.share_time;

    detailContent.querySelector(".message_ip_address").value = client_data?.ip;

    detailContent.querySelector(".message_country").value = client_data?.["cloudfront-viewer-country-name"];
    detailContent.querySelector(".message_city").value = client_data?.["cloudfront-viewer-city"];
    detailContent.querySelector(".message_region").value = client_data?.["cloudfront-viewer-country-region-name"];

    const latitude = notification?.data?.client_data?.["cloudfront-viewer-latitude"];
    const longitude = notification?.data?.client_data?.["cloudfront-viewer-longitude"];

    iframe.src = `https://www.google.com/maps?q=${latitude},${longitude}&output=embed`;

}
// -------
function clear_all_notification() {
    db_Notifications.clear();
    display_notifications();
}
// -------
function jsonToHtml(json, level = 0) {
    const indent = level * 20;

    if (json === null) {
        return `<span class="text-muted fst-italic">null</span>`;
    }

    if (typeof json === 'boolean') {
        return `<span class="text-primary fw-bold">${json}</span>`;
    }

    if (typeof json === 'number') {
        return `<span class="text-info fw-bold">${json}</span>`;
    }

    if (typeof json === 'string') {
        return `<span class="text-success">"${json}"</span>`;
    }

    if (Array.isArray(json)) {
        if (json.length === 0) {
            return `<span class="text-secondary">[ ]</span>`;
        }

        let html = `<div class="border-start border-3 border-secondary ps-3 ms-2 mb-2">`;
        json.forEach((item, i) => {
            html += `<div class="mb-1">
                        <span class="badge bg-secondary me-2">${i}</span>
                        ${jsonToHtml(item, level + 1)}
                    </div>`;
        });
        html += `</div>`;
        return html;
    }

    if (typeof json === 'object') {
        const keys = Object.keys(json);
        if (keys.length === 0) {
            return `<span class="text-secondary">{ }</span>`;
        }

        let html = `<div class="card mb-2 ${level === 0 ? '' : 'ms-3'}">
                    <div class="card-body">`;

        keys.forEach(key => {
            html += `<div class="mb-2">
                        <strong class="text-dark">${key}:</strong>
                        <span class="ms-2">${jsonToHtml(json[key], level + 1)}</span>
                    </div>`;
        });

        html += `</div></div>`;
        return html;
    }

    return `<span>${json}</span>`;
}

// -------
